import { createSlice } from "@reduxjs/toolkit";

export type EsamaptaStateType = {
  position: number[];
  isUpdatePosition: boolean;
};

export const initialEsamamptaState: EsamaptaStateType = {
  position: [-3.0291228, 114.1312603],
  isUpdatePosition: false,
};

export const esamaptaSlice = createSlice({
  name: "esamapta-state",
  initialState: initialEsamamptaState,
  reducers: {
    setPosition: (state, action) => {
      Object.assign(state, action.payload);
    },
    clearPosition: (state) => {
      Object.assign(state, initialEsamamptaState);
    },
  },
});

export const { setPosition, clearPosition } = esamaptaSlice.actions;

export default esamaptaSlice.reducer;
